import { Modal, Button } from "react-bootstrap";
import React from "react";
import { AiOutlineWarning } from "react-icons/ai";

const MockupGenerationError = ({ showModal, modalClose, message }) => {
  return (
    <Modal
      show={showModal}
      onHide={modalClose}
      centered
      backdrop="static"
      contentClassName="rounded-3 shadow-lg border-0"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2 text-danger fw-bold">
          <AiOutlineWarning size={22} />
          Error Processing File
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center px-4 pb-4">
        <p className="mb-3 text-center fs-6 text-muted">
          There was an error with the file you tried to upload. Please make sure
          it follows our{" "}
          <a
            href="https://wonderful-ground-02470df0f.5.azurestaticapps.net/blog/mockup-guide"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none fw-semibold"
          >
            guidelines
          </a>
          .
        </p>
        {message && (
          <p className="mb-3 text-center small text-danger" role="alert">
            {message}
          </p>
        )}

        <Button className="red-btn" onClick={modalClose}>
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default MockupGenerationError;
